import dayjs from 'dayjs'
import { DATE_FORMAT, TIME_FORMAT } from '~/constants/Date'

function getDateFormatted(date: string | Date | undefined): string {
  if (!date) return ''
  const dayjsDate = dayjs(date)
  const today = dayjs()
  const isToday = dayjsDate.isSame(today, 'day')
  const dateFormat = isToday ? '[Today]' : DATE_FORMAT
  return dayjsDate.format(`${dateFormat} - ${TIME_FORMAT}`)
}

export default getDateFormatted
